package navigation.home.suppliers.addeditsupplier

import cafe.adriel.voyager.core.model.StateScreenModel
import cafe.adriel.voyager.core.model.screenModelScope
import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.features.area.domain.repository.AreaRepository
import com.essntl.features.category.domain.repository.CategoryRepository
import com.essntl.features.itinerary.domain.repository.ItineraryRepository
import com.essntl.features.proposal.domain.repository.ProposalRepository
import com.essntl.features.service.domain.repository.ServiceRepository
import com.essntl.features.supplier.domain.repository.SupplierRepository
import com.essntl.features.supplier.ui.addeditsupplier.AddEditSupplierEvent
import com.essntl.features.supplier.ui.addeditsupplier.AddEditSupplierState
import com.essntl.features.supplier.ui.addeditsupplier.AddEditSupplierViewModel
import com.essntl.toastmanager.ToastManager

class AddEditSupplierScreenModel(
    supplierRepository: SupplierRepository,
    categoryRepository: CategoryRepository,
    areaRepository: AreaRepository,
    proposalRepository: ProposalRepository,
    itineraryRepository: ItineraryRepository,
    serviceRepository: ServiceRepository,
    toastManager: ToastManager,
    loadingManager: LoadingManager,
) : StateScreenModel<AddEditSupplierState>(AddEditSupplierState()) {

    private val addEditSupplierViewModel =
        AddEditSupplierViewModel(
            supplierRepository = supplierRepository,
            areaRepository = areaRepository,
            categoryRepository = categoryRepository,
            proposalRepository = proposalRepository,
            itineraryRepository = itineraryRepository,
            serviceRepository = serviceRepository,
            toastManager = toastManager,
            state = mutableState,
            scope = screenModelScope,
            loadingManager = loadingManager,
        )

    fun onEvent(event: AddEditSupplierEvent) {
        addEditSupplierViewModel.onEvent(event)
    }
}
